<template>
    <div :class="{'form-group': true, 'row': inline}">
        <label v-if="label !== false" :for="name" v-text="label" :class="labelClass"></label>

        <div :class="{'col-md-8': inline}">
            <date-picker
                :v-validate="vValidate"
                :value="value"
                :lang="lang"
                :type="type"
                :range="range"
                :format="format"
                :minute-step="10"
                @input="update"
                @change="change"
                @clear="clear"
                class="col-12 p-0"
                :not-before="minDate"
                :not-after="maxDate"
                :input-class="inputClass"
                :input-attr="{
                    name: name,
                    disabled: disabled
                }"
                :placeholder="placeholder"
                :first-day-of-week="1"
                :shortcuts="false"
            ></date-picker>

            <div v-if="errors.has(name, scope)"
                 class="invalid-feedback d-block"
                 role="alert"
            >
                {{ errors.first(name, scope) }}
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { __ } from '../translations/localization'

export default {
  inject: ['$validator'],

  components: {
    DatePicker
  },

  data () {
    return {
      lang: {
        days: [
          __('Sun'),
          __('Mon'),
          __('Tue'),
          __('Wed'),
          __('Thu'),
          __('Fri'),
          __('Sat')
        ],
        months: [
          __('Jan'),
          __('Feb'),
          __('Mar'),
          __('Apr'),
          __('Ma'),
          __('Jun'),
          __('Jul'),
          __('Aug'),
          __('Sep'),
          __('Oct'),
          __('Nov'),
          __('Dec')
        ]
      }
    }
  },

  props: {
    name: String,
    label: [String, Boolean],
    value: [String, Array, Date],
    minDate: String,
    maxDate: String,
    inline: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    vValidate: String,
    scope: String,
    placeholder: {
      type: String,
      default: null
    },
    range: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },    
  },

  methods: {
    update (value) {
      this.$emit('input', value)
    },

    clear () {
      this.$emit('input', null)
      this.$emit('clear')
    },

    change (value) {
      this.$emit('change', value)
    }
  },

  computed: {
    labelClass () {
      return {
        'control-label': true,
        'col-md-4 col-form-label text-md-right': this.inline
      }
    },

    inputClass () {
      return `${this.errors.has(this.name, this.scope) ? 'is-invalid' : ''} form-control`
    }
  }
}
</script>
